import { render, staticRenderFns } from "./SVGLoader.vue?vue&type=template&id=5e8c1815"
import script from "./SVGLoader.vue?vue&type=script&lang=ts"
export * from "./SVGLoader.vue?vue&type=script&lang=ts"
import style0 from "./SVGLoader.vue?vue&type=style&index=0&id=5e8c1815&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports